import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import SegmentedControl from '../../../../Shared/SegmentedControl'

const OPTIONS = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'other', label: 'Other' }
]

export default observer(function GenderFilter() {
  const { search } = useContext(SearchContext)

  const toggleGender = type => {
    if (search.gender.has(type)) {
      search.gender.delete(type)
    } else {
      search.gender.add(type)
    }
  }

  return <SegmentedControl options={OPTIONS} isActive={value => search.gender.has(value)} onSelect={toggleGender} className="w-full [&>button]:flex-1" />
})
